import { inject, Injectable, Signal } from '@angular/core';

import { _ListService } from 'src/app/infrastructure/services/list-services/_list.service';
import { IDomainUserListDto } from 'src/assets/common/models/domain-user-list-dto.g';
import { DomainUserListData, IDomainUserListData } from '../models/domain-user-list-data';
import { tabName } from 'src/app/infrastructure/services/page-services/models/tab-name';
import { Observable } from 'rxjs';
import { LoadingService } from 'src/app/infrastructure/services/loading-services/_loading.service';
import { TabListService } from '../../shared/central-page/services/tab-list.service';
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';

@Injectable()
export class DomainUserListService
    extends _ListService<IDomainUserListDto, IDomainUserListData>
{
    protected override readonly _loadingService = injectRequired(LoadingService);
    protected override readonly _tabListService = inject(TabListService, { optional: true });

    override listActive$ = this._listActive$;
    override hasDeletedList$$ = this._hasDeletedList$$;
    override hasInactiveList$$ = this._hasInactiveList$$;
    // Expliciet als Signal (i.p.v. het afgeleide WritableSignal) getypeerd: DomainUserInvitationListService
    // override't deze met een read-only computed (merge met invitations) en moet daarvoor tegen de
    // bredere Signal-abstractie kunnen typechecken, niet tegen het toevallige WritableSignal van hier.
    override listActive$$: Signal<IDomainUserListData[]> = this._listActive$$;
    override listAll$$: Signal<IDomainUserListData[]> = this._listAll$$;
    override listDeleted$$ = this._listDeleted$$;
    override listDeletedAll$$ = this._listDeletedAll$$;
    override listInactive$$ = this._listInactive$$;

    override listName = tabName.domainUsers;

    override list_refresh$ = this._list_refresh$;

    override list_load$ = this._list_load$;

    override listData_load(listDto: IDomainUserListDto): IDomainUserListData | null {
        return DomainUserListData.create(listDto);
    }
}
